<template>
  <div class="event-list-wrap">
    <div
      v-infinite-scroll="loadMore"
      :infinite-scroll-distance="250"
      :infinite-scroll-throttle-delay="200"
      :loading="!isLoading"
    >
      <my-pooq-empty-list
        v-if="!isLoading && eventList.length === 0"
        info-text="진행중인 이벤트가 없습니다."
      ></my-pooq-empty-list>
      <div v-if="eventList.length > 0">
        <div
          v-for="(event, index) in eventList"
          :key="index"
          class="event-list"
          @click.prevent="() => goEvent(event)"
        >
          <a href="#">
            <div class="picture-area">
              <WebpImage
                :image-info="{
                  imageUrl: event.listImage,
                  width: 375,
                  height: 211,
                  alt: event.eventTitle,
                }"
              />
            </div>
            <strong class="event-tit">{{ event.eventTitle }}</strong>
          </a>
          <p v-if="event.startDate && event.endDate" class="event-text">
            <span>기간</span>
            <span class="title-dot"></span>
            <span>{{ event.startDate }} ~ {{ event.endDate }}</span>
          </p>
          <p v-if="event.gift" class="event-text">
            <span>경품</span>
            <span class="title-dot"></span>
            <span>{{ event.gift }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { infiniteScroll } from '@/common/directives'
  import { get, indexOf } from 'lodash'
  import MyPooqEmptyList from '@/components/lnb/mypooq/MyPooqEmptyList'
  import { isApp } from '@/common/util/common'
  import { resizeThumbnail } from '@/common/image.filter'
  import WebpImage from '@/components/image/WebpImage'
  import { getEventList } from '@/common/requests/data-fetch'

  export default {
    name: 'EventList',
    components: {
      WebpImage,
      MyPooqEmptyList,
    },
    directives: {
      infiniteScroll,
    },
    data() {
      return {
        endOfList: false,
        offset: 0,
        limit: 10,
        eventList: [],
        isLoading: true,
        offsetData: [],
      }
    },
    methods: {
      getImage(img) {
        return resizeThumbnail(img, {
          width: 0,
          height: 0,
          option: '20',
          quality: 80,
        })
      },
      goEvent(event) {
        //  event_type: 'view' | 'promotion' | 'landing'
        const { eventId, eventType, landingUrl } = event

        // eventType: landing인 경우 새 창 open (app인 경우 외부 브라우저로 open)
        if (eventType === 'landing') {
          if (isApp()) {
            location.href = `captvpooq://webview?url=${encodeURIComponent(landingUrl)}&external=y`
          } else {
            window.open(landingUrl, '_blank')
          }
          return
        }
        if (isApp()) {
          location.href = `captvpooq://customer/event_view?eventId=${eventId}`
        } else {
          this.$router.push(`/event/detail/${eventId}`)
        }
      },
      loadMore() {
        if (this.endOfList) return
        this.setData()
      },
      setData() {
        this.isLoading = true
        if (indexOf(this.offsetData, this.offset) > -1) return
        this.offsetData.push(this.offset)
        getEventList({
          status: 'all',
          offset: this.offset,
          limit: this.limit,
        }).then(({ data }) => {
          const resList = get(data, 'list', [])
          this.endOfList = resList.length === 0
          this.offset += this.limit
          this.eventList = this.eventList.concat(resList)
          this.isLoading = false
        })
      },
    },
  }
</script>

<style scoped>
  .event-list-wrap {
    width: 100%;
    height: 100%;
    /*overflow-y: scroll;*/
    /*overflow-scrolling: touch;*/
    /*-webkit-overflow-scrolling: touch;*/
  }
  .event-list-wrap::-webkit-scrollbar {
    display: none;
    background-color: transparent;
  }
  .event-list-wrap > div {
    height: 100%;
  }
  .event-list {
    padding-bottom: 20px;
  }
  .event-list .picture-area,
  .event-list .picture-area img {
    border-radius: 0;
  }
  .event-list .picture-area {
    position: relative;
    display: block;
    padding-top: 56.3%;
    overflow: hidden;
  }
  .event-list .picture-area img {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    min-height: 100%;
    width: 100%;
  }
  .event-tit,
  .event-tit02 {
    display: block;
    color: #fff;
  }
  .event-tit {
    padding: 16px 16px 8px;
    font-size: 18px;
    line-height: 1;
    font-weight: 400;
  }
  .event-text {
    padding: 0 16px;
    font-size: 0;
  }
  .event-text + .event-text {
    margin-top: 2px;
  }
  .event-text > span:not(.title-dot) {
    font-size: 12px;
    line-height: 18px;
    color: #a5a5a5;
  }
  .event-text > span {
    vertical-align: middle;
  }
  .title-cc-line,
  .title-dot,
  .title-s-dot {
    display: inline-block;
    vertical-align: middle;
    margin: 0 3px;
    border-radius: 50%;
    border: 1px solid #a5a5a5;
  }
  .title-cc-line,
  .title-dot {
    width: 4px;
    height: 4px;
  }
</style>
